import { render, staticRenderFns } from "./egame.vue?vue&type=template&id=67585eea&scoped=true&"
import script from "./egame.vue?vue&type=script&lang=js&"
export * from "./egame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67585eea",
  null
  
)

export default component.exports